import { render, staticRenderFns } from "./TopicComponent.vue?vue&type=template&id=efbdc9d4&"
import script from "./TopicComponent.vue?vue&type=script&lang=js&"
export * from "./TopicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports